import { render, staticRenderFns } from "./AcoesProrrogar.vue?vue&type=template&id=6c7f67de&scoped=true"
import script from "./AcoesProrrogar.vue?vue&type=script&lang=js"
export * from "./AcoesProrrogar.vue?vue&type=script&lang=js"
import style0 from "./AcoesProrrogar.vue?vue&type=style&index=0&id=6c7f67de&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f67de",
  null
  
)

export default component.exports